// Subscription product constants for Recall
// Internal IDs match the tier keys used by the backend.
// Apple product IDs follow the Wolf Technologies convention:
//   uk.co.wolftechnologies.<appname>.<tier>.<duration>

export const PRODUCTS = {
  PREMIUM_MONTHLY: 'monthly',
  PREMIUM_YEARLY: 'yearly',
};

// Apple App Store product IDs (as registered in App Store Connect)
export const APPLE_PRODUCT_IDS = {
  [PRODUCTS.PREMIUM_MONTHLY]: 'uk.co.wolftechnologies.recall.premium.monthly',
  [PRODUCTS.PREMIUM_YEARLY]: 'uk.co.wolftechnologies.recall.premium.yearly',
};

// Reverse mapping: Apple product ID → internal product ID (the tier key)
export const APPLE_TO_INTERNAL = Object.fromEntries(
  Object.entries(APPLE_PRODUCT_IDS).map(([internal, apple]) => [apple, internal])
);

// Free-tier AI generation allowance (lifetime). Mirrors AI_GEN_LIMIT_FREE in
// amplify/backend/.../lib/subscription.mjs — the server is authoritative;
// this constant only drives the "N of 3 used" chip in AiDeckGenerator.
export const AI_GEN_LIMIT_FREE = 3;

// Reverse mapping: Apple product ID → { tier, period } (canonical IAP shape).
// Mirrors APPLE_PRODUCT_MAP in amplify/backend/.../routes/subscription.mjs.
export const APPLE_TO_TIER = {
  [APPLE_PRODUCT_IDS[PRODUCTS.PREMIUM_MONTHLY]]: { tier: PRODUCTS.PREMIUM_MONTHLY, period: 'monthly' },
  [APPLE_PRODUCT_IDS[PRODUCTS.PREMIUM_YEARLY]]:  { tier: PRODUCTS.PREMIUM_YEARLY,  period: 'yearly'  },
};
